import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ForgotPassword.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    try {
      setIsSubmitting(true);
      setError(null);
      setMessage(null);

      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/request-password-reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to send reset email');
      }

      setMessage(data.message);
      setSubmitted(true);

    } catch (err) {
      console.error('Password reset request error:', err);
      setError(err.message || 'Failed to send reset email. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="forgot-password-header">
          <h1>Reset Password</h1>
          <p className="subtitle">Enter your email to receive a password reset link</p>
        </div>

        {submitted ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Check Your Email</h2>
            <p>{message}</p>
            <p className="hint">
              If you don't see the email, check your spam folder. The link will expire in 1 hour.
            </p>
            <div className="action-buttons">
              <Link to="/login" className="btn-primary">
                Back to Login
              </Link>
              <button 
                className="btn-secondary" 
                onClick={() => {
                  setSubmitted(false);
                  setEmail('');
                  setMessage(null);
                }}
              >
                Send Another Email
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="forgot-password-form">
            {error && (
              <div className="error-message">
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your.email@example.com"
                disabled={isSubmitting}
                autoFocus
                required
              />
              <span className="field-hint">
                Enter the email address associated with your account
              </span>
            </div>

            <button 
              type="submit" 
              className="btn-primary btn-full-width"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className="form-footer">
              <Link to="/login" className="link">
                ← Back to Login
              </Link>
              <span className="divider">•</span>
              <Link to="/register" className="link">
                Create Account
              </Link>
            </div>

            <div className="info-box">
              <p><strong>Note:</strong> If you signed up with Google, you cannot reset your password here. Please use "Sign in with Google" instead.</p>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
